
<template>
  <div>
    <p>
      Read Only Mode
    </p>
    <SwitchFlag
      :value="readOnlyMode"
      :label-mapping="labelMapping"
      @switchFlag="manageReadMode({
        enabled: $event,
      })" />
  </div>
</template>
<script>
import {
  mapActions, mapGetters,
} from 'vuex';
import SwitchFlag from '../SiteSettingsSwitchFlag';
export default {
  name: 'SiteSettingsReadOnlyMode',
  components: {
    SwitchFlag,
  },
  data() {
    return {
      labelMapping: {
        off: 'Turn off readonly mode',
        on: 'Turn on readonly mode',
      },
    };
  },
  computed: {
    ...mapGetters({
      readOnlyMode: 'SiteConfiguration/readOnlyMode',
    }),
  },
  methods: {
    ...mapActions({
      manageReadMode: 'SiteConfiguration/manageReadMode',
    }),
  },
};
</script>